module.exports = __webpack_public_path__ + "static/media/card_m2.cc888a0f.jpg";